  <div class="message-text" [innerHtml]="message | translate"></div>